import { Crud } from 'models/common/Edit';

export enum aprTplNm {
  NAME = '',
}

export interface ApprovalTemplate extends Crud {
  aprRuleId: string;
  aprTplId: string;
  intgAprTpCd: string;
  aprTplNm: string;
  sortOrd: number;
  aprTplDesc: string;
  useYn: string;
  prsDesc: string;
  ntdkId: number;
  wcstUseYn: string;
  wcstDesc: string;
  notfUseYn: string;
  mgrUseYn: string;
}
export interface ApprovalTemplate {
  aprRuleId: string;
  aprTplId: string;
  intgAprTpCd: string;
  aprTplNm: string;
  sortOrd: number;
  aprTplDesc: string;
  useYn: string;
  prsDesc: string;
  ntdkId: number;
  wcstUseYn: string;
  wcstDesc: string;
  notfUseYn: string;
  mgrUseYn: string;
}
